import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Button, ButtonGroup } from 'react-bootstrap'
import {
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap'
import { sendRequestAccess, requestAccessOpenPage } from './../../../../users'

import config from '../../../../../config'

import './styles'
import right_Check_Image from 'images/icon_notification_success.png'

function RequestAccess() {
  const dispatch = useDispatch()
  const signup = useSelector((state) => state.users.signup)
  const [searchParams] = useSearchParams()
  const emailFieldRef = useRef(null)
  const isFirstSignupRender = useRef(true)

  const [submitForm, setSubmitForm] = useState(false)
  const [formFields, setFormFields] = useState({
    email: searchParams.get('email') || '',
    firstName: '',
    lastName: '',
    jobTitle: '',
    phoneExt: '',
    phone: '',
    brokerageLocation: '',
  })
  const [errorGroup, setErrorGroup] = useState({})
  const [errorStatus, setErrorStatus] = useState(false)

  useEffect(() => {
    dispatch(requestAccessOpenPage({ email: formFields.email }))
    if (emailFieldRef.current) {
      emailFieldRef.current.focus()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isFirstSignupRender.current) {
      isFirstSignupRender.current = false
      return
    }
    const { requestStatus } = signup || {}
    if (requestStatus) {
      setSubmitForm(true)
    } else {
      setErrorStatus(true)
    }
  }, [signup])

  const handleSubmit = (e) => {
    e.preventDefault()
    const { email, firstName, lastName, phone, phoneExt, jobTitle, brokerageLocation } =
      formFields
    const newErrorGroup = {
      email: email.length === 0,
      firstName: firstName.length === 0,
      lastName: lastName.length === 0,
      phone: phone.length === 0,
      brokerageLocation: brokerageLocation.length === 0,
    }
    const allValid = Object.keys(newErrorGroup).every((k) => !newErrorGroup[k])
    if (!allValid) {
      setErrorGroup(newErrorGroup)
      setErrorStatus(true)
    } else {
      dispatch(
        sendRequestAccess({
          userData: {
            email,
            firstName,
            lastName,
            phone,
            phoneExt,
            brokerageLocation,
            jobTitle,
          },
        }),
      )
    }
  }

  const handleChange = (e) => {
    const { id, value } = e.target
    setFormFields((prev) => ({ ...prev, [id]: value }))
    if (errorStatus) {
      const newErrorGroup = { ...errorGroup, [id]: value.length === 0 }
      setErrorGroup(newErrorGroup)
      setErrorStatus(Object.values(newErrorGroup).every(Boolean))
    }
  }

  const { email, firstName, lastName, jobTitle, phoneExt, phone, brokerageLocation } =
    formFields

  return (
    <div className="container">
      {submitForm && <VerifyMessage email={email} />}
      <Row>
        <Col mdOffset={4} md={4}>
          {!submitForm && (
            <form onSubmit={handleSubmit}>
              <h1>Request Access to Owner&apos;s Edge</h1>
              <p>Unfortunately we don&apos;t recognize your email address</p>
              <FormGroup controlId="email">
                <ControlLabel>Email</ControlLabel>
                <FormControl
                  id="email"
                  type="text"
                  label="Email"
                  value={email}
                  onChange={handleChange}
                  inputRef={(ref) => {
                    emailFieldRef.current = ref
                  }}
                />
                <ErrorBlock errorFlag={errorGroup.email} />
              </FormGroup>
              <FormGroup controlId="firstName">
                <ControlLabel>First Name</ControlLabel>
                <FormControl
                  id="firstName"
                  type="text"
                  label="Text"
                  value={firstName}
                  onChange={handleChange}
                />
                <ErrorBlock errorFlag={errorGroup.firstName} />
              </FormGroup>
              <FormGroup controlId="lastName">
                <ControlLabel>Last Name</ControlLabel>
                <FormControl
                  id="lastName"
                  type="text"
                  label="Text"
                  value={lastName}
                  onChange={handleChange}
                />
                <ErrorBlock errorFlag={errorGroup.lastName} />
              </FormGroup>
              <FormGroup controlId="jobTitle">
                <ControlLabel>Job Title</ControlLabel>
                <FormControl
                  id="jobTitle"
                  type="text"
                  label="Text"
                  placeholder="optional"
                  value={jobTitle}
                  onChange={handleChange}
                />
              </FormGroup>
              <Row>
                <Col xs={8} sm={8} md={8} lg={8}>
                  <FormGroup controlId="phone">
                    <ControlLabel>Phone Number</ControlLabel>
                    <FormControl
                      id="phone"
                      type="text"
                      label="Text"
                      value={phone}
                      onChange={handleChange}
                    />
                    <ErrorBlock errorFlag={errorGroup.phone} />
                  </FormGroup>
                </Col>
                <Col xs={4} sm={4} md={4} lg={4}>
                  <FormGroup controlId="phoneExt">
                    <ControlLabel>Ext</ControlLabel>
                    <FormControl
                      id="phoneExt"
                      type="text"
                      label="Text"
                      placeholder="optional"
                      value={phoneExt}
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup controlId="brokerageLocation">
                <ControlLabel>Brokerage and Location</ControlLabel>
                <FormControl
                  id="brokerageLocation"
                  type="text"
                  label="brokerageLocation"
                  value={brokerageLocation}
                  onChange={handleChange}
                />
                <ErrorBlock errorFlag={errorGroup.brokerageLocation} />
              </FormGroup>
              <Row style={{ marginBottom: '20px' }}>
                <Col mdOffset={2} md={11}>
                  <ButtonGroup>
                    <Button bsStyle="default" type="submit">
                      Request Access
                    </Button>
                    <a className="cancelLink" href={`${config.landingPageUrl}`}>
                      Cancel
                    </a>
                    <ErrorBlock
                      errorFlag={errorStatus}
                      errorMessage="*Not All required fields are filled out!"
                    />
                  </ButtonGroup>
                </Col>
              </Row>
            </form>
          )}
        </Col>
      </Row>
    </div>
  )
}

const ErrorBlock = ({ errorFlag, errorMessage = '*Required' }) => {
  return errorFlag ? <HelpBlock className="helpBlockRed">{errorMessage}</HelpBlock> : null
}

const VerifyMessage = (props) => {
  return (
    <div className="verifyMessage">
      <div className="pull-left mr-x2 ml-x2">
        <img src={right_Check_Image} alt="Argo" />
      </div>
      <div className="pull-right">
        <h1>An underwriter will be in touch</h1>
        <p>
          We will verify your details and send invitation to {props.email}, or contact you
          for more information.
        </p>
        <a className="btn btn-link pn mt" href={`${config.landingPageUrl}`}>
          Back to product overview
        </a>
      </div>
    </div>
  )
}

RequestAccess.propTypes = {
  error: PropTypes.bool,
}

export default RequestAccess
